import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup } from "devextreme-react";
import { lastStep, nextStep, setDataNewComplain, setCiudadesComunas, setCodigoArea, setCodigoAreaAll } from "../../actions";
import TextField from "../../../../../../Shared/fields/TextField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import DirectionFields from "../fields/DirectionsFields";
import DateField from "../../../../../../Shared/fields/DateField";
// import { ChangeAddressAutocomplete } from "../../../../../../Maps/actions";
import { getCiudadesComunas, getCodigoArea, getCodigoAreaAll } from "../../../../../../../helpers/direccionesNuevaDenunciaFormat";
import validaciones from "../../../../../../../helpers/validaciones";

class InfoTrabajador extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      firstEdit: !props.editingDraft,
    };
  }

  componentDidMount = () => {
    if (this.props.listaCodigoArea && this.props.listaCodigoArea.length === 0) {
      this.props.dispatch(setCodigoAreaAll(getCodigoAreaAll(this.props.listaDirecciones)));
    }
  }

  handleBack = () => {
    this.props.dispatch(lastStep());
  }

  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      // Limpiar el autocomplete de la direccion google
      this.props.dispatch(nextStep());
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };
    jsonData.formInfoTrabajador[e.element.id] = e.value;

    switch (e.element.id) {
      case "Sucursal": {
        jsonData.formInfoTrabajador.RegionSucursal = "";
        jsonData.formInfoTrabajador.ComunaSucursal = "";
        jsonData.formInfoTrabajador.TipoCalleSucursal = "";
        jsonData.formInfoTrabajador.NombreCalleSucursal = "";
        jsonData.formInfoTrabajador.NumeroCalleSucursal = "";
        jsonData.formInfoTrabajador.PoblacionVillaSucursal = "";
        jsonData.formInfoTrabajador.CiudadLocalidadSucursal = "";
        jsonData.formInfoTrabajador.SucursalCode = "";
        jsonData.formInfoTrabajador.SucursalPhone = "";
        break;
      }
      case "Region": {
        const result = getCiudadesComunas(this.props.listaDirecciones, e.value.IdRegion);
        this.props.dispatch(setCiudadesComunas(result.listaCiudades, result.listaComunas.sort(validaciones.sortComunas)));
        jsonData.formInfoTrabajador.Comuna = null;
        jsonData.formInfoTrabajador.Ciudad = null;
        jsonData.formInfoTrabajador.Code = null;
        jsonData.formInfoTrabajador.CodeList = [];
        break;
      }
      case "Comuna": {
        const result = getCodigoArea(e.value.CodigoArea);
        this.props.dispatch(setCodigoArea(result));
        jsonData.formInfoTrabajador.Code = null;
        jsonData.formInfoTrabajador.CodeList = result;
        break;
      }
      default:
        break;
    }

    this.props.dispatch(setDataNewComplain(jsonData));
    if (this.state.firstEdit && !this.props.editingDraft && jsonData.formInfoTrabajador.Birthdate) {
      this.setState({ firstEdit: false });
      this.props.onCreate();
    }
  }

  render() {
    // if (!form.TipoDireccion) form.TipoDireccion = "Google Maps";

    return (
      <ValidationGroup className="row">
        <div className="col-12 newDenuncia-title"> {/* ref={this.topRef}> */}
          <h2>Información del trabajador</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>
        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Datos trabajador</h4>

          <TextField
            label="Rut"
            disabled
            id="Rut"
            value={this.props.jsonData.formInfoDenuncia.rutTxt}
            onChange={this.handleChange}
          />

          <TextField
            label="Nombres"
            maxLength={80}
            required
            disabled={this.props.dataTrabajador.FirstName != null && this.props.dataTrabajador.FirstName !== ""}
            id="FirstName"
            value={this.props.jsonData.formInfoTrabajador.FirstName}
            onChange={this.handleChange}
          />

          <TextField
            label="Apellido paterno"
            required
            maxLength={30}
            disabled={this.props.dataTrabajador.LastName != null && this.props.dataTrabajador.LastName !== ""}
            id="LastName"
            value={this.props.jsonData.formInfoTrabajador.LastName}
            onChange={this.handleChange}
          />

          <TextField
            label="Apellido materno"
            required
            maxLength={30}
            disabled={this.props.dataTrabajador.MothersName != null && this.props.dataTrabajador.MothersName !== ""}
            id="MothersName"
            value={this.props.jsonData.formInfoTrabajador.MothersName}
            onChange={this.handleChange}
          />

          <DateField
            label="Fecha de nacimiento"
            id="Birthdate"
            required
            value={this.props.jsonData.formInfoTrabajador.Birthdate}
            onChange={this.handleChange}
            type="date"

          />
          <SelectField
            label="Sexo"
            id="Sexo"
            required
            value={this.props.jsonData.formInfoTrabajador.Sexo}
            dataSource={this.props.listaSexos}
            displayExpr="Sexo"
            acceptCustomValue
            onChange={this.handleChange}
          />

          <SelectField
            label="Nacionalidad"
            id="Nacionalidad"
            required
            searchEnabled
            searchExpr={["Nacionalidad"]}
            value={this.props.jsonData.formInfoTrabajador.Nacionalidad}
            dataSource={this.props.listaNacionalidades}
            displayExpr="Nacionalidad"
            acceptCustomValue
            onChange={this.handleChange}
          />

          <SelectField
            label="Pueblo originario"
            id="PuebloOriginario"
            required
            value={this.props.jsonData.formInfoTrabajador.PuebloOriginario}
            dataSource={this.props.listaPueblosOriginarios}
            displayExpr="PuebloOriginario"
            acceptCustomValue
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Dirección personal del trabajador</h4>

          <DirectionFields
            onChange={this.handleChange}
            form={this.props.jsonData.formInfoTrabajador}
            renderPhone
          />
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Información laboral del trabajador</h4>

          <SelectField
            label="Profesión u oficio"
            id="ProfesionOficio"
            required
            dataSource={this.props.listaProfesiones}
            searchEnabled
            searchExpr={["Ocupacion"]}
            displayExpr="Ocupacion"
            value={this.props.jsonData.formInfoTrabajador.ProfesionOficio}
            acceptCustomValue
            onChange={this.handleChange}
          />

          <SelectField
            label="Categoría ocupacional"
            id="CategoriaOcupacional"
            required
            value={this.props.jsonData.formInfoTrabajador.CategoriaOcupacional}
            dataSource={this.props.listaCategoriasOcupacionales}
            displayExpr="CategoriaOcupacional"
            onChange={this.handleChange}
            acceptCustomValue
          />

          <SelectField
            label="Tipo de ingreso"
            id="TipoIngreso"
            required
            value={this.props.jsonData.formInfoTrabajador.TipoIngreso}
            dataSource={this.props.listaTiposIngreso}
            displayExpr="TipoIngreso"
            onChange={this.handleChange}
            acceptCustomValue
          />

          <SelectField
            label="Tipo de contrato"
            id="TipoContrato"
            required
            value={this.props.jsonData.formInfoTrabajador.TipoContrato}
            dataSource={this.props.listaTiposContrato}
            displayExpr="TipoContrato"
            onChange={this.handleChange}
            acceptCustomValue
          />

          <DateField
            label="Fecha de contratación"
            id="Antiguedad"
            required
            value={this.props.jsonData.formInfoTrabajador.Antiguedad}
            onChange={this.handleChange}
            type="date"

          />

          <div className="row zero-vertical">
            <div className="col-6 zero-right">
              <DateField
                id="HoraIngreso"
                label="Hora de ingreso al trabajo"
                required
                value={this.props.jsonData.formInfoTrabajador.HoraIngreso}
                onChange={this.handleChange}
                type="time"
              />
            </div>
            <div className="col-6">
              <DateField
                id="HoraSalida"
                label="Hora de salida del trabajo"
                required
                value={this.props.jsonData.formInfoTrabajador.HoraSalida}
                onChange={this.handleChange}
                type="time"
              />
            </div>
          </div>
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Sucursal donde trabaja</h4>
          <SelectField
            label="Sucursal"
            id="Sucursal"
            required
            value={this.props.jsonData.formInfoTrabajador.Sucursal}
            dataSource={this.props.listaSucursales}
            searchEnabled
            searchExpr={["Direccion"]}
            displayExpr="Direccion"
            acceptCustomValue
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12">
          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>
      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.denuncias.jsonData,
  showHideForm: state.denuncias.showHideForm,
  editingDraft: state.denuncias.editingDraft,
  dataTrabajador: state.denuncias.dataTrabajador,
  listaSexos: state.global.listaSexos,
  listaNacionalidades: state.global.listaNacionalidades,
  listaPueblosOriginarios: state.global.listaPueblosOriginarios,
  listaCategoriasOcupacionales: state.global.listaCategoriasOcupacionales,
  listaTiposIngreso: state.global.listaTiposIngreso,
  listaTiposContrato: state.global.listaTiposContrato,
  listaTiposCalle: state.global.listaTiposCalle,
  listaSucursales: state.denuncias.validSucursales,
  listaProfesiones: state.global.listaProfesiones,
  listaDirecciones: state.global.listaDirecciones,
  listaCodigoArea: state.denuncias.listaCodigoAreaAll,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoTrabajador);
